import React from "react"
import { AppCrudTable } from "@components"
import { useProviderSuppliersMappingTableData } from "Pages/Admin/ProvidersSuppliersMapping/@hooks"
import { capitalize, Skeleton } from "@mui/material"
import { normalizedDataColumn, rawDataColumn } from "Pages/Admin/ProvidersSuppliersMapping/Table/@columns"
import MultiProvidersSuppliersMappingTableToolbar from "Pages/Admin/ProvidersSuppliersMapping/Table/MultiToolbar"

export default function ProvidersSuppliersMappingTable({ type = 'providers' }) {
	const { data, isLoading } = useProviderSuppliersMappingTableData(type)


	return isLoading
		? <Skeleton variant="rectangular" height={770}/>
		: <AppCrudTable
			title={`${type === 'providers' ? capitalize(type) : 'Web Suppliers'} Mapping data`}
			data={data}
			columns={[rawDataColumn(), normalizedDataColumn()]}
			options={{
				selectableRows: 'multiple',
				customToolbarSelect: (selectedData, setSelectedRows) => <MultiProvidersSuppliersMappingTableToolbar
					type={type}
					selectedData={selectedData}
					setSelectedRows={setSelectedRows}/>,
				tableBodyHeight: "600",
				search: true,
			}}
		/>
}